<template>
	<!-- Item của combo không có column -->
	<li
		class="combobox-item single"
		:class="{ parent: item.is_parent }"
		:style="'text-align: ' + align"
		v-if="comboType === 1"
		v-on="listeners"
	>
		<div class="combobox-item-con">
			<div class="combobox-item--text" :title="getItemDisplay(item)">
				{{ getItemDisplay(item) }}
			</div>
			<span
				class="trash-icon"
				v-if="hasRemoveItemButton"
				@click="onRemoveItemClick()"
			>
				<span class="mi mi-16 mi-garbage"></span>
			</span>
		</div>
	</li>
	<li
		class="combobox-item single"
		:class="[
			{ parent: item.isParent },
			{ 'combobox-item-custom': isCustomComboxOrg },
			{ 'org-notemail': !item.InvRevEmail },
			indexItem >= 0 ? `transform-translate-item-${indexItem}` : ''
		]"
		:style="'text-align: ' + align"
		v-else-if="comboType === 3 && columnx.length == 0 && isCustomComboxOrg"
		v-on="listeners"
	>
		<div class="combobox-item-con">
			<div
				:class="[
					item.level ? `level-${item.level}` : `level-0`,
					item.Childrens && item.Childrens.length > 0
						? 'font-bold'
						: ''
				]"
			>
				<div class="ms-text-overflow" v-if="item.Name" :title="item.Name">
					<span class="font-bold">{{ item.Name }}</span>
				</div>
				<div v-if="item.InvRevEmail" class="" :title="item.InvRevEmail">
					{{ item.InvRevEmail }}
				</div>
			</div>
			<div class="mi-new-v2 mi-16 mi-icon-v2-tick-select" v-if="isSelected"></div>
			<span
				class="trash-icon"
				v-if="hasRemoveItemButton"
				@click="onRemoveItemClick()"
			>
				<span class="mi mi-16 mi-garbage"></span>
			</span>
		</div>
	</li>
	<li
		class="combobox-item single"
		:class="[{ parent: item.isParent }]"
		:style="'text-align: ' + align"
		v-else-if="comboType === 3 && columnx.length == 0"
		v-on="listeners"
	>
		<div class="combobox-item-con">
			<div
				class=""
				:class="[
					item.level ? `level-${item.level}` : `level-0`,
					item.Childrens && item.Childrens.length > 0
						? 'font-bold'
						: ''
				]"
				:title="getItemDisplay(item)"
			>
				{{ getItemDisplay(item) }}
			</div>
			<span
				class="trash-icon"
				v-if="hasRemoveItemButton"
				@click="onRemoveItemClick()"
			>
				<span class="mi mi-16 mi-garbage"></span>
			</span>
		</div>
	</li>
	<!-- Item của combo có column -->
	<tr
		class="combobox-item"
		:class="[
			{ parent: item.isParent },
			{ 'org-notemail': isCustomComboxOrg && !item.InvRevEmail }
		]"
		v-else
		v-on="listeners"
	>
		<td
			class="combobox-item-td"
			v-for="(column, tdIndex) in columnx"
			:ref="`td-${tdIndex}`"
			:key="column.dataField"
			:class="
				comboType === 3 && tdIndex === 0 ? `level-${item.level}` : null
			"
			:style="getTdStyle(column, tdIndex)"
		>
			<div
				v-if="isCustomComboxOrg && column.dataField === 'InvRevEmail'"
				class="combobox-item-td--contents combobox-item-td--email"
			>
				<div v-if="item.InvRevEmail" class="combobox-item-td--text" :title="item.InvRevEmail">
					{{ item.InvRevEmail }}
				</div>
				<div class="mi-new-v2 mi-16 mi-icon-v2-tick-select" v-if="isSelected"></div>
			</div>
			<div v-else class="combobox-item-td--contents">
				<div
					:title="getItemDisplay(item, column)"
					class="combobox-item-td--text"
				>
					{{ getItemDisplay(item, column) }}
				</div>
			</div>
		</td>
		<td class="selected-container" v-if="item.multiSelected">
			<div class="selected"></div>
		</td>
	</tr>
</template>

<script>
export default {
	name: 'MsComboBoxItem',
	props: {
		/**
		 * Loại combo
		 */
		comboType: {
			type: Number,
			default: 1
		},

		/**
		 * Item sử dụng để binding
		 */
		item: {},

		/**
		 * Cấu hình cột của menu
		 */
		columnx: {
			type: Array,
			default: []
		},
		/**
		 * Trường làm value
		 * CreatedBy PDKIEN 10/12/2019
		 */
		valueField: {
			type: String,
			default: null
		},
		/**
		 * Trường là display
		 * CreatedBy PDKIEN 10/12/2019
		 */
		displayField: {
			type: String,
			default: null
		},

		/**
		 * Trạng thái có btn `Xóa` trong item
		 */
		hasRemoveItemButton: {
			type: Boolean,
			default: false
		},
		/**
		 * Kiểu định dạng dữ liệu trên combobox
		 * Tương ứng với FormatType
		 * CreatedBy PDKIEN 07/12/2019
		 */
		formatType: {
			type: [Number, String],
			default: null
		},
		align: {
			type: String,
			default: 'left'
		},
		//Custom lại combobox cho chi nhánh hình cây
		isCustomComboxOrg: {
			type: Boolean,
			default: false
		},
		indexItem: {
			type: Number,
			default: null
		},
		//Giá trị được chọn để hiển thị icon tick
		selectedValue: {
			default: null
		}
	},
	computed: {
		/**
		 * Binding sự kiện của menu item
		 */
		listeners() {
			const me = this;
			return {
				...me.$listeners
			};
		},
		/**
		 * Kiểm tra item hiện tại có được chọn không
		 */
		isSelected() {
			const me = this;
			if (!me.valueField || !me.selectedValue) return false;
			return me.item[me.valueField] === me.selectedValue;
		}
	},
	mounted() {
		const me = this;
		if (me.indexItem >= 0) {
			let itemElement = document.querySelector(
				`transform-translate-item-${me.indexItem}`
			);
			if (itemElement && itemElement.length > 0) {

			}
		}
	},
	methods: {
		/**
		 * Hàm lấy style cho td trong table
		 * dữ liệu động theo config của dev
		 */
		getTdStyle(column, index) {
			if (column.isResize) {
				if (
					this.$refs[`td-${index}`] &&
					this.$refs[`td-${index}`].length > 0
				) {
					let item = this.$refs[`td-${index}`][0];
					let rectTd = item.getBoundingClientRect();
					let rectParent = this.$parent.$el.getBoundingClientRect();
					if (rectTd.right <= rectParent.right) {
						return {
							width:
								rectTd.width +
								(rectParent.right - rectTd.right) +
								'px',
							textAlign: column.columnAlign
						};
					} else {
						return {
							width: `${column.width}px`,
							textAlign: column.columnAlign
						};
					}
				}
			}
			return {
				width: column.isResize ? null : `${column.width}px`,
				textAlign: column.columnAlign
			};
		},

		/**
		 * Lấy text hiển thị trên item
		 * Nếu có column lấy theo column.field, nếu không có column lấy theo displayField, nếu không có displayField lấy theo valueField
		 * CreatedBy PDKIEN 10/12/2019
		 */
		getItemDisplay(item, column) {
			let field = column
				? column.dataField
				: this.displayField || this.valueField;
			if (field) {
				return item[field];
			} else {
				return item;
			}
		},

		/**
		 * Xử lý sự kiện khi click icon xóa item
		 */
		onRemoveItemClick() {
			this.$emit('removeItem');
		}
	}
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msComboboxItem.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msComboboxItem.scss';
}

.combobox-item-custom {
	line-height: unset;
	width: 100%;
	min-height: 36px; // đồng bộ $ms-grid__line-height, hardcode vì ngoài scope @media import biến
	display: flex !important;
	align-items: center;
	justify-content: space-between;
}
.org-notemail {
	cursor: unset;
	&:hover {
		background: unset;
	}
}

.ms-text-overflow{
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	max-width: 100%;
}

.mi-icon-v2-tick-select {
	flex-shrink: 0;
	margin-left: 8px;
}

</style>
